/**
 * Custom HTML component terms
 *
 * @package ext-components-pro
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const customHtml = {
	component: {
		label: "component:customHtml#label",
		description: "component:customHtml#description"
	}
};
